// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 761 ? "copilot" : chunkId) + "." + {"212":"95294e73","453":"a63d4ca6","761":"61ccedea"}[chunkId] + ".chunk.js";
};